import { useTranslation } from "react-i18next";
import { Crown, SlidersHorizontal } from "lucide-react";

const TABS = [
  ["super_admin", Crown],
  ["platform_admin", SlidersHorizontal],
];

// تبويبان: مالك بمطلق الصلاحيات، أو إداري بصلاحيات مؤشَّرة يدوياً.
export const RoleTabs = ({ value, onChange }) => {
  const { t } = useTranslation();
  return (
    <div className="flex gap-2" data-testid="role-tabs">
      {TABS.map(([role, Icon]) => {
        const active = value === role;
        return (
          <button
            key={role}
            type="button"
            data-testid={`role-tab-${role}`}
            onClick={() => onChange(role)}
            className={`flex flex-1 items-center justify-center gap-2 rounded-2xl px-4 py-3 text-xs font-bold transition-colors ${
              active ? "neu-in text-primary" : "neu text-muted-foreground"
            }`}
          >
            <Icon className="h-4 w-4" />
            {t(`staff.tabs.${role}`)}
          </button>
        );
      })}
    </div>
  );
};
